import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

class NavigationHelper extends Component {
  state = {
    currentA11yMessage: ""
  };

  componentDidUpdate(prevProps) {
    if (prevProps.currentA11yMessage !== this.props.currentA11yMessage) {
      setTimeout(() => {
        this.setState({
          currentA11yMessage: this.props.currentA11yMessage
        });
      }, 50);
      setTimeout(() => {
        this.setState({
          currentA11yMessage: ""
        });
      }, 100);
    }
  }

  render() {
    const { title, metaDescription } = this.props;
    const { currentA11yMessage } = this.state;

    return (
      <ScreenReaderOnly aria-live="polite" aria-atomic="true">
        {currentA11yMessage ? <span>Navigated to {currentA11yMessage}</span> : ""}
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={metaDescription} />
        </Helmet>
      </ScreenReaderOnly>
    );
  }
}

const mapStateToProps = ({
  currentA11yMessage: { screenReaderMessage: currentA11yMessage, title, metaDescription }
}) => ({
  currentA11yMessage,
  title,
  metaDescription
});

export default connect(mapStateToProps)(NavigationHelper);

const ScreenReaderOnly = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
